import { Translated } from "@cda-libs/cda-models";

export const functionsUrl = "";

/**
 * @ https://firebase.google.com/docs/reference/js/auth#autherrorcodes
 * @ https://firebase.google.com/docs/auth/admin/errors
 * @copyright https://stackoverflow.com/questions/39152004/where-can-i-find-a-list-of-all-error-codes-and-messages-for-firebase-authenticat
 */
export const FBErrors: Record<string, Translated> = {
    "auth/admin-restricted-operation": {
        en: "This operation is restricted to administrators only.",
        es: "This operation is restricted to administrators only.",
    },
    "auth/argument-error": {
        en: "",
        es: "",
    },
    "auth/app-not-authorized": {
        en: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        es: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
    },
    "auth/app-not-installed": {
        en: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        es: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
    },
    "auth/captcha-check-failed": {
        en: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        es: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
    },
    "auth/code-expired": {
        en: "The SMS code has expired. Please re-send the verification code to try again.",
        es: "The SMS code has expired. Please re-send the verification code to try again.",
    },
    "auth/cordova-not-ready": {
        en: "Cordova framework is not ready.",
        es: "Cordova framework is not ready.",
    },
    "auth/cors-unsupported": {
        en: "This browser is not supported.",
        es: "This browser is not supported.",
    },
    "auth/credential-already-in-use": {
        en: "This credential is already associated with a different user account.",
        es: "This credential is already associated with a different user account.",
    },
    "auth/custom-token-mismatch": {
        en: "The custom token corresponds to a different audience.",
        es: "The custom token corresponds to a different audience.",
    },
    "auth/requires-recent-login": {
        en: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        es: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
    },
    "auth/dynamic-link-not-activated": {
        en: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        es: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
    },
    "auth/email-change-needs-verification": {
        en: "Multi-factor users must always have a verified email.",
        es: "Multi-factor users must always have a verified email.",
    },
    "auth/email-already-in-use": {
        en: "The email address is already in use by another account.",
        es: "The email address is already in use by another account.",
    },
    "auth/expired-action-code": {
        en: "The action code has expired. ",
        es: "The action code has expired. ",
    },
    "auth/cancelled-popup-request": {
        en: "This operation has been cancelled due to another conflicting popup being opened.",
        es: "This operation has been cancelled due to another conflicting popup being opened.",
    },
    "auth/internal-error": {
        en: "An internal error has occurred.",
        es: "An internal error has occurred.",
    },
    "auth/invalid-app-credential": {
        en: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        es: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
    },
    "auth/invalid-app-id": {
        en: "The mobile app identifier is not registed for the current project.",
        es: "The mobile app identifier is not registed for the current project.",
    },
    "auth/invalid-user-token": {
        en: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        es: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
    },
    "auth/invalid-auth-event": {
        en: "An internal error has occurred.",
        es: "An internal error has occurred.",
    },
    "auth/invalid-verification-code": {
        en: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
        es: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
    },
    "auth/invalid-continue-uri": {
        en: "The continue URL provided in the request is invalid.",
        es: "The continue URL provided in the request is invalid.",
    },
    "auth/invalid-cordova-configuration": {
        en: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        es: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
    },
    "auth/invalid-custom-token": {
        en: "The custom token format is incorrect. Please check the documentation.",
        es: "The custom token format is incorrect. Please check the documentation.",
    },
    "auth/invalid-dynamic-link-domain": {
        en: "The provided dynamic link domain is not configured or authorized for the current project.",
        es: "The provided dynamic link domain is not configured or authorized for the current project.",
    },
    "auth/invalid-email": {
        en: "The email address is badly formatted.",
        es: "The email address is badly formatted.",
    },
    "auth/invalid-api-key": {
        en: "Your API key is invalid, please check you have copied it correctly.",
        es: "Your API key is invalid, please check you have copied it correctly.",
    },
    "auth/invalid-cert-hash": {
        en: "The SHA-1 certificate hash provided is invalid.",
        es: "The SHA-1 certificate hash provided is invalid.",
    },
    "auth/invalid-credential": {
        en: "The supplied auth credential is malformed or has expired.",
        es: "The supplied auth credential is malformed or has expired.",
    },
    "auth/invalid-message-payload": {
        en: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        es: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
    },
    "auth/invalid-multi-factor-session": {
        en: "The request does not contain a valid proof of first factor successful sign-in.",
        es: "The request does not contain a valid proof of first factor successful sign-in.",
    },
    "auth/invalid-oauth-provider": {
        en: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        es: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
    },
    "auth/invalid-oauth-client-id": {
        en: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        es: "The OAuth client ID provided is either invalid or does not match the specified API key.",
    },
    "auth/unauthorized-domain": {
        en: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        es: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
    },
    "auth/invalid-action-code": {
        en: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        es: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
    },
    "auth/wrong-password": {
        en: /* "The password is wrong."*/ "Invalid user credentials",
        es: /* "The password is wrong."*/ "Invalid user credentials",
    },
    "auth/invalid-persistence-type": {
        en: "The specified persistence type is invalid. It can only be local, session or none.",
        es: "The specified persistence type is invalid. It can only be local, session or none.",
    },
    "auth/invalid-phone-number": {
        en: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        es: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
    },
    "auth/invalid-provider-id": {
        en: "The specified provider ID is invalid.",
        es: "The specified provider ID is invalid.",
    },
    "auth/invalid-recipient-email": {
        en: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        es: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
    },
    "auth/invalid-sender": {
        en: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        es: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
    },
    "auth/invalid-verification-id": {
        en: "The verification ID used to create the phone auth credential is invalid.",
        es: "The verification ID used to create the phone auth credential is invalid.",
    },
    "auth/invalid-tenant-id": {
        en: "The Auth instance's tenant ID is invalid.",
        es: "The Auth instance's tenant ID is invalid.",
    },
    "auth/multi-factor-info-not-found": {
        en: "The user does not have a second factor matching the identifier provided.",
        es: "The user does not have a second factor matching the identifier provided.",
    },
    "auth/multi-factor-auth-required": {
        en: "Proof of ownership of a second factor is required to complete sign-in.",
        es: "Proof of ownership of a second factor is required to complete sign-in.",
    },
    "auth/missing-android-pkg-name": {
        en: "An Android Package Name must be provided if the Android App is required to be installed.",
        es: "An Android Package Name must be provided if the Android App is required to be installed.",
    },
    "auth/auth-domain-config-required": {
        en: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        es: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
    },
    "auth/missing-app-credential": {
        en: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        es: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
    },
    "auth/missing-verification-code": {
        en: "The phone auth credential was created with an empty SMS verification code.",
        es: "The phone auth credential was created with an empty SMS verification code.",
    },
    "auth/missing-continue-uri": {
        en: "A continue URL must be provided in the request.",
        es: "A continue URL must be provided in the request.",
    },
    "auth/missing-iframe-start": {
        en: "An internal error has occurred.",
        es: "An internal error has occurred.",
    },
    "auth/missing-ios-bundle-id": {
        en: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        es: "An iOS Bundle ID must be provided if an App Store ID is provided.",
    },
    "auth/missing-multi-factor-info": {
        en: "No second factor identifier is provided.",
        es: "No second factor identifier is provided.",
    },
    "auth/missing-multi-factor-session": {
        en: "The request is missing proof of first factor successful sign-in.",
        es: "The request is missing proof of first factor successful sign-in.",
    },
    "auth/missing-or-invalid-nonce": {
        en: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        es: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
    },
    "auth/missing-phone-number": {
        en: "To send verification codes, provide a phone number for the recipient.",
        es: "To send verification codes, provide a phone number for the recipient.",
    },
    "auth/missing-verification-id": {
        en: "The phone auth credential was created with an empty verification ID.",
        es: "The phone auth credential was created with an empty verification ID.",
    },
    "auth/app-deleted": {
        en: "This instance of FirebaseApp has been deleted.",
        es: "This instance of FirebaseApp has been deleted.",
    },
    "auth/account-exists-with-different-credential": {
        en: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        es: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
    },
    "auth/network-request-failed": {
        en: "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
        es: "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
    },
    "auth/no-auth-event": {
        en: "An internal error has occurred.",
        es: "An internal error has occurred.",
    },
    "auth/no-such-provider": {
        en: "User was not linked to an account with the given provider.",
        es: "User was not linked to an account with the given provider.",
    },
    "auth/null-user": {
        en: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        es: "A null user object was provided as the argument for an operation which requires a non-null user object.",
    },
    "auth/operation-not-allowed": {
        en: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        es: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
    },
    "auth/operation-not-supported-in-this-environment": {
        en: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        es: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
    },
    "auth/popup-blocked": {
        en: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        es: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
    },
    "auth/popup-closed-by-user": {
        en: "The popup has been closed by the user before finalizing the operation.",
        es: "The popup has been closed by the user before finalizing the operation.",
    },
    "auth/provider-already-linked": {
        en: "User can only be linked to one identity for the given provider.",
        es: "User can only be linked to one identity for the given provider.",
    },
    "auth/quota-exceeded": {
        en: "The project's quota for this operation has been exceeded.",
        es: "The project's quota for this operation has been exceeded.",
    },
    "auth/redirect-cancelled-by-user": {
        en: "The redirect operation has been cancelled by the user before finalizing.",
        es: "The redirect operation has been cancelled by the user before finalizing.",
    },
    "auth/redirect-operation-pending": {
        en: "A redirect sign-in operation is already pending.",
        es: "A redirect sign-in operation is already pending.",
    },
    "auth/rejected-credential": {
        en: "The request contains malformed or mismatching credentials.",
        es: "The request contains malformed or mismatching credentials.",
    },
    "auth/second-factor-already-in-use": {
        en: "The second factor is already enrolled on this account.",
        es: "The second factor is already enrolled on this account.",
    },
    "auth/maximum-second-factor-count-exceeded": {
        en: "The maximum allowed number of second factors on a user has been exceeded.",
        es: "The maximum allowed number of second factors on a user has been exceeded.",
    },
    "auth/tenant-id-mismatch": {
        en: "The provided tenant ID does not match the Auth instance's tenant ID",
        es: "The provided tenant ID does not match the Auth instance's tenant ID",
    },
    "auth/timeout": {
        en: "The operation has timed out.",
        es: "The operation has timed out.",
    },
    "auth/user-token-expired": {
        en: "The user's credential is no longer valid. The user must sign in again.",
        es: "The user's credential is no longer valid. The user must sign in again.",
    },
    "auth/too-many-requests": {
        en: "We have blocked all requests from this device due to unusual activity. Try again later.",
        es: "We have blocked all requests from this device due to unusual activity. Try again later.",
    },
    "auth/unauthorized-continue-uri": {
        en: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        es: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
    },
    "auth/unsupported-first-factor": {
        en: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        es: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
    },
    "auth/unsupported-persistence-type": {
        en: "The current environment does not support the specified persistence type.",
        es: "The current environment does not support the specified persistence type.",
    },
    "auth/unsupported-tenant-operation": {
        en: "This operation is not supported in a multi-tenant context.",
        es: "This operation is not supported in a multi-tenant context.",
    },
    "auth/unverified-email": {
        en: "The operation requires a verified email.",
        es: "The operation requires a verified email.",
    },
    "auth/user-cancelled": {
        en: "The user did not grant your application the permissions it requested.",
        es: "The user did not grant your application the permissions it requested.",
    },
    "auth/user-not-found": {
        en: "There is no user record corresponding to this identifier. The user may have been deleted.",
        es: "There is no user record corresponding to this identifier. The user may have been deleted.",
    },
    "auth/user-disabled": {
        en: "The user account has been disabled by an administrator.",
        es: "The user account has been disabled by an administrator.",
    },
    "auth/user-mismatch": {
        en: "The supplied credentials do not correspond to the previously signed in user.",
        es: "The supplied credentials do not correspond to the previously signed in user.",
    },
    "auth/user-signed-out": {
        en: "",
        es: "",
    },
    "auth/weak-password": {
        en: "The password must be 6 characters long or more.",
        es: "The password must be 6 characters long or more.",
    },
    "auth/web-storage-unsupported": {
        en: "This browser is not supported or 3rd party cookies and data may be disabled.",
        es: "This browser is not supported or 3rd party cookies and data may be disabled.",
    },
}